import { EntitySubType, FireDangerRatingEntity, HazardPriorityMapping } from '@/features';

/**
 * Sort the selected day's Fire Danger Ratings by priority and alphabetically.
 * @param fireDangerRatings The array of Fire Danger Rating entities to sort.
 * @param selectedDateIndex The index of the selected date to determine priority.
 * @returns The sorted array of Fire Danger Rating entities.
 */
export const sortFireDangerRatings = (fireDangerRatings: FireDangerRatingEntity[], selectedDateIndex: number): FireDangerRatingEntity[] => {
  return fireDangerRatings.sort((a, b) => {
    const bPriority =
      HazardPriorityMapping[b.forecasts[selectedDateIndex]?.fdrSubType as (typeof EntitySubType)[keyof typeof EntitySubType]] ?? 0;
    const aPriority =
      HazardPriorityMapping[a.forecasts[selectedDateIndex]?.fdrSubType as (typeof EntitySubType)[keyof typeof EntitySubType]] ?? 0;

    return bPriority - aPriority || (a.title || '').localeCompare(b.title || '');
  });
};
